<div class="isg-full-page-header">

  <div class="isg-page-header isg-toolbar">

    <a routerLink="/admin/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-table" title="Back to licenses"></span>
    </a>

    <a routerLink="/admin/user/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user" title="License Users"></span>
    </a>

    <a routerLink="/admin/user/permission"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user-shield" title="User Permissions"></span>
    </a>

    <span>Role Management for {{companyName}}</span>
  </div>

  <div class="isg-page-body" [style.height.px]="height">

    <div class="isg-role-page" [class.isg-module-hide]="hideModule" [class.isg-datatree-hide]="hideAuthDataTree">

      <div class="isg-module" [ngClass]="{'isg-module-hide': hideModule}" style="margin-right:24px;">

        <div class="isg-subheader">
          <span>Modules</span>
        </div>
        <div class="isg-module-list">
          <app-modules-list [licenseId]="currentLicenseId"
                            [includeHost]="true"
                            (selected)="onModuleSelected($event)"
                            (dataLoaded)="onModulesLoaded($event)">
          </app-modules-list>
        </div>
      </div>

      <div class="isg-role">

        <div class="isg-subheader">
          <span>Roles </span>
        </div>

        <div class="isg-role-list">
          <app-roles-list [moduleId]="currentModuleId"
                          [licenseId]="currentLicenseId"
                          [showToolbar]="true"
                          [showSaveButton]="hasRoleSave"
                          [showReadOnlyButton]="hasRoleDetail && !(hasRoleSave)"
                          [showDelButton]="hasRoleDelete"
                          [showTemplateButton]="hasRoleTemplate"
                          [widthThreshold]="1000"
                          (selected)="onRoleSelected($event)"
                          (saveRolePermissionsClicked)="onSaveRolePermissionsClicked($event)">
          </app-roles-list>
        </div>

      </div>

      <div class="isg-role-auth-visual" style="margin-left:24px;">

        <div class="isg-subheader">
          <span>Menus/Display</span>
        </div>

        <div class="isg-role-auth-visual">
          <app-auth-tree #authtreevisual
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [authTypes]="['M', 'V', 'PP']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="hasRoleSave"
                         [showCreateButton]="hasPermCreate"
                         [showEditButton]="hasPermEdit"
                         [showReadOnlyButton]="hasPermDetail && !(hasPermEdit)"
                         [showReorderButton]="hasPermReOrder"
                         [showDeleteButton]="hasPermDelete"
                         [enableSaveButton]="!!(currentRoleId)"
                         [widthThreshold]="1000">

          </app-auth-tree>
        </div>

      </div>

      <div class="isg-role-auth-data" [ngClass]="{'isg-datatree-hide': hideAuthDataTree}" style="margin-left:24px;">

        <div class="isg-subheader">
          <span>Data</span>
        </div>

        <div class="isg-role-auth-data">
          <app-auth-tree #authtreedata
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [authTypes]="['D', 'PBI']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="hasRoleSave"
                         [showCreateButton]="hasPermCreate"
                         [showEditButton]="hasPermEdit"
                         [showReadOnlyButton]="hasPermDetail && !(hasPermEdit)"
                         [showReorderButton]="hasPermReOrder"
                         [showDeleteButton]="hasPermDelete"
                         [enableSaveButton]="!!(currentRoleId)"
                         [widthThreshold]="1000"
                         (dataLoaded)="onDataTreeLoaded($event)">
          </app-auth-tree>
        </div>

      </div>

      <div class="isg-role-users" style="margin-left:24px;">

        <div class="isg-subheader">
          <span>Role Users</span>
        </div>

        <div class="isg-role-users">
          <app-user-list [moduleId]="currentModuleId"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [showLicenseFilter]="true"
                         [widthThreshold]="1000">

          </app-user-list>
        </div>

      </div>

    </div>

  </div>

</div>

